
import { RegionStub } from "templates/fragments/region";
import { CountryBase } from "templates/fragments/country";
import {monthSlugsWithOverview as monthSlugs} from 'services/centralStore';



export default ({ location,monthIndex,isCountryInstance }: { location: RegionStub | CountryBase, monthIndex: number, isCountryInstance: boolean}): string => {
    let path;
    let continent = (location as CountryBase).continent || (location as RegionStub).country.continent;
    if (isCountryInstance || (location as RegionStub).isCountry) {
        path = `/${continent}/${location.slug}-weather-${monthSlugs[monthIndex]}/`
    }
    else {
        path = `/${continent}/${(location as RegionStub).country.slug}/${location.slug}-weather-${monthSlugs[monthIndex]}/`
    }
    return path;
}